import {useTranslation} from "react-i18next";

import ServicesList from "./ServicesList";
import AccordionList from "./AccordionList";

const ServicesPage = () => {

    const { t } = useTranslation();

    return (
        <main id="services-page">
            <section className="space-ptb">
                <div className="container text-center space-ptb">
                    <h2 className="mb-4">{t('servicesPage.subTitle0')}</h2>
                    <h1 className="mb-4"dangerouslySetInnerHTML={{ __html: t('servicesPage.title0') as string }}></h1>
                    <p>{t('servicesPage.description0')}</p>
                </div>
            </section>
            <section className="services-list space-ptb">
                <div className="container-fluid w-special">
                    <h2 className="mb-4">{t('servicesPage.subTitle1')}</h2>
                    <h3 className="mb-4" dangerouslySetInnerHTML={{ __html: t('servicesPage.title1') as string }}></h3>
                    <ServicesList />
                </div>
            </section>
            <section className="space-ptb guaranty-section">
                <div className="container-fluid w-special">
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-6 order-lg-1 mb-4 mb-lg-5">
                            <h2>{t('servicesPage.subTitle2')}</h2>
                            <h4>{t('servicesPage.title2')}</h4>
                            <p>{t('servicesPage.description2-1')}</p>
                            <p>{t('servicesPage.description2-2')}</p>
                        </div>
                        <div className="col-12 col-lg-6 order-lg-2 mb-4 mb-lg-5">
                            <img src="/assets/images/services/servizi1.webp" alt="Servizi 1" className="img-fluid" />
                        </div>
                        <div className="col-12 col-lg-6 order-lg-4 mb-4 mb-lg-5">
                            <h2>{t('servicesPage.subTitle3')}</h2>
                            <h4>{t('servicesPage.title3')}</h4>
                            <p>{t('servicesPage.description3-1')}</p>
                            <p>{t('servicesPage.description3-2')}</p>
                        </div>
                        <div className="col-12 col-lg-6 order-lg-3 mb-4 mb-lg-5">
                            <img src="/assets/images/services/servizi2.webp" alt="Servizi 2" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="space-ptb faq-section">
                <div className="container-fluid w-special">
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <h2>{t('servicesPage.subTitle4')}</h2>
                            <h3>{t('servicesPage.title4')}</h3>
                        </div>
                        <div className="col-12 col-lg-8">
                            <AccordionList />
                        </div>
                    </div>
                </div>
            </section>

        </main>
    );
};

export default ServicesPage;